export { default as Layout } from "../../../layouts/default";
export { default as About } from "./about";
export { default as Profile } from "./profile";
